import { Injectable } from '@angular/core';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SensorInfoService {

  constructor(private clientApiService: ClientBaseApiService) { }

  deviceExist(payload: { deviceType: string, deviceId: string }) {
    let url = environment.baseApiUrl+"v2/api/" + "device/exist";
    return this.clientApiService.baseApiCall<boolean>({ url, payload: payload, requestType: HttpRequestTypes.POST })
  }
}
